<template>
  <div>
    <div class="day_record_box">
      <div class="owner_title_day">
        金主日结登记
      </div>
      <el-date-picker
        popper-class="date-picker"
        size="mini"
        v-model="timeData"
        value-format="yyyy-MM-dd HH:mm:ss"
        type="datetimerange"
        @change="timeChange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :default-time="['00:00:00', '23:59:59']"
      >
      </el-date-picker>
    </div>

    <!-- 筛选 -->
    <div class="btn_box">
      <div class="day_record_btn">
        <div class="book_btn" @click="downloadFile()" :disable="isLock">
          <i class="iconfont icon-xiazai"></i>
          下载文件
        </div>
      </div>
      <div class="task_filtrate" @click="show_filter_form()">
        <i class="iconfont icon-shaixuan1"></i>
        <span>筛选</span>
      </div>
    </div>

    <!-- 筛选表单 -->
    <div class="task_filter_form" v-show="isFilterForm">
      <el-form
        ref="filter_form"
        :model="filter_form"
        :inline="true"
        class="demo-form-inline"
        label-width="100px"
      >
        <el-form-item label="书名" prop="connectionessay_name">
          <el-input v-model="filter_form.connectionessay_name"></el-input>
        </el-form-item>
        <el-form-item label="金主昵称" prop="mobile">
          <el-input v-model="filter_form.mobile"></el-input>
        </el-form-item>
        <el-form-item label="结算状态" prop="is_settle">
          <el-select v-model="filter_form.is_settle" placeholder="结算状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="未结算" value="0"></el-option>
            <el-option label="已结算" value="1"></el-option>
          </el-select>
        </el-form-item>
        <div class="filter_btn">
          <el-button type="primary" icon="el-icon-search" @click="goSearch"
            >搜索</el-button
          >
        </div>
      </el-form>
    </div>

    <div class="task_box">
      <!-- 表格数据 -->
      <el-table
        :data="dayRecordList"
        @selection-change="handleSelectionChange"
        tooltip-effect="dark"
        height="550"
        border
      >
        <el-table-column type="selection" width="40"></el-table-column>
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>

        <el-table-column
          property="connection_name"
          label="金主昵称"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="connectionessay_name"
          label="书名"
          align="center"
          sortable
          width="80"
        ></el-table-column>
        <el-table-column
          property="start_chapters"
          label="开始章节"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="end_chapters"
          label="结束章节"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="word_number"
          label="入库字数"
          align="center"
          sortable
          width="110"
        ></el-table-column>
        <el-table-column
          property="actual_cost"
          label="金主给的千字价格"
          align="center"
          sortable
          width="165"
        ></el-table-column>
        <el-table-column
          property="each_chapter_num"
          label="每章字数"
          align="center"
          sortable
          width="120"
        >
        </el-table-column>
        <el-table-column
          property="thousand_diff"
          label="差价"
          align="center"
          sortable
          width="80"
        >
        </el-table-column>
        <el-table-column
          property="fee"
          label="实际应收稿费"
          align="center"
          sortable
          width="135"
        >
        </el-table-column>
        <el-table-column
          property="frequency"
          label="日结第几天"
          align="center"
          sortable
          width="130"
        >
        </el-table-column>
        <el-table-column
          property="settlement_type"
          label="日周结"
          align="center"
          sortable
          width="90"
        >
          <template slot-scope="scope">
            <el-tag
              class="day_tag"
              :type="scope.row.settlement_type == '2' ? '' : 'warning'"
            >
              {{ scope.row.settlement_type == "2" ? "周结" : "日结" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="is_settle"
          label="日结状态"
          align="center"
          sortable
          width="110"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.is_settle == '0' ? 'info' : 'success'">
              {{ scope.row.is_settle == "0" ? "未结算" : "已结算" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="status"
          label="是否通过"
          align="center"
          sortable
          width="110"
        >
          <!-- "status": 1,//是否通过:0=审查中,1=通过,-1=驳回 -->
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.status == '0'
                  ? ' '
                  : scope.row.status == '1'
                  ? 'success'
                  : 'danger'
              "
            >
              {{
                scope.row.status == "0"
                  ? "审查中"
                  : scope.row.status == "1"
                  ? "通过"
                  : "驳回"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="qd_remark"
          label="备注"
          align="center"
          sortable
          width="90"
        >
        </el-table-column>
        <el-table-column
          property="createtime"
          label="创建时间"
          align="center"
          sortable
          width="110"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <div class="day_control_box">
              <div @click="rejectDialog(scope.row)" class="reject_record_btn">
                <i class="iconfont icon-jujue"></i>
                驳回
              </div>
              <div @click="editRemark(scope.row)" class="reject_record_btn">
                <i class="iconfont icon-register"></i>
                修改备注
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 驳回弹窗 -->
    <el-dialog
      title="驳回"
      class="dialog_box"
      :visible.sync="rejectDialogVisible"
      width="90%"
      center
    >
      <el-form ref="rejectForm" :model="rejectForm" label-width="100px">
        <el-form-item label="填写原因：">
          <el-input v-model="rejectForm.suggestions"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="submitReject"
          >确认驳回</el-button
        >
        <el-button class="dialog_btn" round @click="rejectDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 修改备注弹窗 -->
    <el-dialog
      title="修改备注"
      class="dialog_box"
      :visible.sync="remarkDialogVisible"
      width="90%"
      center
    >
      <el-form ref="remarkForm" :model="remarkForm" label-width="100px">
        <el-form-item label="备注">
          <el-input v-model="remarkForm.qd_remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="dialog_btn" round type="primary" @click="submitRemark"
          >确认</el-button
        >
        <el-button class="dialog_btn" round @click="remarkDialogVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  connectionrecord_day_list,
  connectionrecord_day_reject,
  connectionrecord_day_endorse,
  connectionrecord_day_zip,
  connectionrecord_qd_remark
} from "@/utils/owner";
export default {
  data() {
    return {
      baseUrl: this.$global.commonUrl,
      dayRecordList: [], //日结登记列表
      isFilterForm: true, //筛选表单
      rejectDialogVisible: false, //驳回弹窗
      remarkDialogVisible: false, //修改备注弹窗
      currentId: null, //当前选中的id
      selectIdList: [], //多选列表
      selectIds: [], //多选id列表
      // 驳回表单
      rejectForm: {
        suggestions: ""
      },

      filterTime: "", //筛选时间
      day_start: "", //开始时间
      day_end: "", //结束时间
      // 筛选
      filter_form: {
        connectionessay_name: "", //书名
        connection_name: "", //金主昵称
        is_settle: "" //结算状态
      },
      timeData: [], //时间筛选
      remarkId: "", //修改弹窗备注id
      // 修改备注表单
      remarkForm: {
        qd_remark: ""
      },
      isLock: false //按钮的点击次数
    };
  },
  created() {
    this.ownerId = JSON.parse(localStorage.getItem("userInfo")).id;

    this.getDayRecordList();
  },
  methods: {
    // 获取金主日结登记列表
    getDayRecordList(time, filter) {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        createtime: time,
        page: 1,
        page_index: 10,
        ...filter
      };
      connectionrecord_day_list(obj).then(res => {
        if (res.data.code == 1) {
          that.dayRecordList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 筛选
    goSearch() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        page: 1,
        page_index: 10,
        createtime: that.filterTime,
        ...that.filter_form
      };
      connectionrecord_day_list(obj).then(res => {
        if (res.data.code == 1) {
          that.dayRecordList = res.data.data;
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    // 修改备注
    editRemark(val) {
      var that = this;
      that.remarkDialogVisible = true;
      that.remarkId = val.id;
      that.remarkForm.qd_remark = val.qd_remark;
    },
    // 提交修改备注
    submitRemark() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionrecord_id: that.remarkId,
        qd_remark: that.remarkForm.qd_remark
      };
      connectionrecord_qd_remark(obj).then(res => {
        if (res.data.code == 1) {
          that.remarkDialogVisible = false;
          that.$message.success(res.data.msg);
          that.getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    // 时间段筛选
    timeChange(val) {
      var that = this;
      that.day_start = val[0];
      that.day_end = val[1];
      that.filterTime = that.day_start + " - " + that.day_end;
      that.goSearch();
    },
    // 多选操作
    handleSelectionChange(val) {
      var that = this;
      var select_arr = [];
      val.forEach(element => {
        select_arr.push(element.id);
      });
      that.selectIds = select_arr;
    },
    // 驳回弹窗
    rejectDialog(val) {
      var that = this;
      that.rejectDialogVisible = true;
      that.currentId = val.id;
      that.rejectForm.suggestions = "";
    },
    // 驳回
    submitReject() {
      var that = this;
      let obj = {
        departmentuser_id: that.ownerId,
        connectionrecord_id: that.currentId,
        suggestions: that.rejectForm.suggestions
      };
      connectionrecord_day_reject(obj).then(res => {
        if (res.data.code == 1) {
          that.rejectDialogVisible = false;
          that.$message.success(res.data.msg);
          that.getDayRecordList(that.filterTime, that.filter_form);
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },

    //下载文件
    downloadFile() {
      var that = this;

      let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
      var select_ids = that.selectIds.join(",");
      if (that.selectIds.length == 0) {
        return false;
      }
      let obj = {
        departmentuser_id: that.ownerId,
        connectionrecord_ids: select_ids
      };
      let information = {
        obj: obj
      };

      if (!flag) {
        if (that.isLock == true) {
          this.$message.error("请勿频繁点击！");
          setTimeout(() => {
            this.isLock = false;
          }, 5000);
        } else {
          connectionrecord_day_zip(obj).then(res => {
            if (res.data.code == 1) {
              let file_name = res.data.data.title;
              let url = res.data.data.url;

              var suffix = url.substring(url.lastIndexOf(".")); //zip
              if (suffix == "zip") {
                var link = document.createElement("a");
                link.style.display = "none";
                link.href = url;
                link.setAttribute("download", file_name);
                console.log(link);
                document.body.appendChild(link);
                link.click();
              } else {
                // console.log("doc文件名", file_name, url);
                // this.download(url, file_name);
                // const xhr = new XMLHttpRequest();
                // xhr.open("GET", url, true); // url 文件的完整地址 http:XXX
                // xhr.responseType = "blob";
                // xhr.onload = function() {
                //   if (xhr.status === 200) {
                //     const res = xhr.response;
                //     const link = document.createElement("a");
                //     link.style.display = "none";
                //     const url = window.URL.createObjectURL(res);
                //     link.href = url;
                //     link.setAttribute("download", file_name);
                //     document.body.appendChild(link);
                //     link.click();
                //     window.URL.revokeObjectURL(link.href);
                //     document.body.removeChild(link);
                //   }
                // };
                // xhr.send();
              }
              that.$message.success(res.data.msg);
            } else {
              this.$message.error(res.data.msg);
            }
          });
          this.isLock = true;
        }
      } else {
        //这是关键代码
        this.$router.push({
          path: "downloadFile",
          query: {
            information: JSON.stringify(information), //先转为字符串
            pathURL: "OwnerDayRecordMobile",
            sataus: "down"
          }
        });
      }
    },

    // 打开筛选表单
    show_filter_form() {
      var that = this;
      that.isFilterForm = !that.isFilterForm;
    }
  }
};
</script>
<style scoped>
.el-main {
  margin: 0px;
  padding: 0px;
  background: #f5f7fa;
}

.owner_title_day {
  font-size: 17px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #304265;
  background: #ffffff;
  padding: 15px;
}
.day_record_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  background: #ffffff;
  border: 1px solid #e4e9f1;
}

.table_box {
  margin: 0px 15px;
}

.reject_record_btn {
  width: 90px;
  height: 20px;
  line-height: 20px;
  background: #e7f2ff;
  border-radius: 10px;
  font-size: 12px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #157df8;
  margin-bottom: 5px;
}
.reject_record_btn i {
  font-size: 12px;
}

.sea_icon {
  font-size: 12px;
}
.task_box {
  margin: 0px 15px;
}
.task_filtrate {
  text-align: right;
  padding: 10px 15px 10px 15px;
}

.task_filtrate i {
  font-size: 14px;
}

.task_filtrate span {
  font-size: 14px;
  font-family: Source Han Sans CN-Regular, Source Han Sans CN;
  font-weight: 400;
  color: #8893a7;
}

.task_filter_form {
  background: #ffffff;
  margin: 0px 16px;
  padding-top: 15px;
}

.pagination_box {
  float: right;
  margin-top: 15px;
  margin-right: 15px;
}
.btn_box {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0px 15px;
}
.book_btn {
  width: 100px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #e7f2ff;
  border-radius: 4px;
  color: #157df8;
  font-size: 14px;
  margin-right: 5px;
}
.day_record_btn,
.day_control_box {
  display: flex;
  flex-direction: column;
}
.filter_btn {
  margin-left: 30px;
  padding-bottom: 5px;
}
.day_tag {
  margin-left: 0px;
}
.task_box {
  margin-bottom: 150px;
}
</style>
<style>
/* 移动端 */
/* .el-picker-panel {
  width: 372px !important;
}
.el-date-range-picker .el-picker-panel__body {
  min-width: 373px !important;
}
.el-date-range-picker__content .el-date-range-picker__header div {
  margin-left: 0 !important;
  margin-right: 15px !important;
}
.el-input__inner {
  padding: 0px 3px !important;
}
.el-date-editor .el-range-input {
  width: 70% !important;
} */
</style>



// WEBPACK FOOTER //
// src/view/owner/OwnerDayRecordMobile.vue